
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
import { FormTextarea } from "@/components/ui/form-textarea";

interface MessageInputProps {
  onSendMessage: (message: string) => void;
  isLoading: boolean;
}

const MessageInput: React.FC<MessageInputProps> = ({ onSendMessage, isLoading }) => {
  const [message, setMessage] = useState("");

  const handleSendMessage = () => {
    if (!message.trim()) return;
    onSendMessage(message);
    setMessage("");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <div className="flex items-start gap-2 p-4 w-full max-w-full">
      <div className="flex-grow w-full max-w-[calc(100%-60px)]">
        <FormTextarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Share your faith with love and truth..."
          className="w-full"
          disabled={isLoading}
        />
      </div>
      <Button 
        onClick={handleSendMessage} 
        disabled={!message.trim() || isLoading}
        className="bg-heaven-gold hover:bg-heaven-dark-gold shrink-0"
      >
        <Send className="h-5 w-5" />
      </Button>
    </div>
  );
};

export default MessageInput;
